/*
HOW TO
MAKE IMAGE ARRAY AND PASS TO preload.startLoad
------------------------------------------------
preload.startLoad(imgArry).then( res => {
	console.log("all done")
});
*/

export let preload = {
	count: 0,
	max : 0,
	arry: [],
	startLoad: function(arry){
		return new Promise((resolve, reject) =>{
			preload.count 	= 0;
			preload.max 	= arry.length;
			preload.arry 	= arry;
			preload.load().then(res => {
				resolve();
			});
		});
	},
	load: function(){
		return new Promise( (resolve, reject) => {
			loadImg();
			function loadImg(){
				var newImg = new Image();
				newImg.src = preload.arry[preload.count];
				newImg.onload = function(){
					preload.count++;
					if(preload.count < preload.max){
						loadImg();
					}else{
						resolve();
					}
				}
			}
		});
	}
}

export let loadResources = (resources) => {
	//console.log("loadResources", resources);
	return new Promise( (resolve, reject) => {
		const totalResources = resources.length;
		let count = 0;
		resources.forEach( ($img, index) => {
			//console.log(resource, index, totalResources);
			if( $img.complete ){
				updateProgress();
			}else{
				$img.addEventListener('load', updateProgress);
				$img.addEventListener('error', updateProgress);
			}
		});
		function updateProgress(e){
			//console.log(count, totalResources, e.target.alt );
			count++;
			let progress = (count / totalResources)*50 + 50;
			document.querySelector("#loading .bar").style.width = `${progress}%`;
			if( count === totalResources ){
				resolve();
			}
		}
	});
}